import { render } from "./MarketplacesMarken.vue?vue&type=template&id=a4f179e8"
import script from "./MarketplacesMarken.vue?vue&type=script&lang=ts"
export * from "./MarketplacesMarken.vue?vue&type=script&lang=ts"

import "./MarketplacesMarken.vue?vue&type=style&index=0&id=a4f179e8&lang=scss"
script.render = render

export default script